






















import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, defineComponent, computed } from '@nuxtjs/composition-api';
import { useConfig, useUiState } from '~/composables';
import AppHeader from '~/components/AppHeader.vue';
import BottomNavigation from '~/components/BottomNavigation.vue';
import IconSprite from '~/components/General/IconSprite.vue';
import PtHeader from '~/components/Pointeger/organisms/PtHeader.vue';

export default defineComponent({
  name: 'DefaultLayout',

  components: {
    PtHeader,
    LazyHydrate,
    AppHeader,
    BottomNavigation,
    IconSprite,
    AppFooter: () => import(/* webpackPrefetch: true */ '~/components/AppFooter.vue'),
    CartSidebar: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/CartSidebar.vue'),
    WishlistSidebar: () => import(/* webpackPrefetch: true */ '~/modules/wishlist/components/WishlistSidebar.vue'),
    LoginModal: () => import(/* webpackPrefetch: true */ '~/modules/customer/components/LoginModal/LoginModal.vue'),
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },

  setup() {
    const route = useRoute();
    const { config } = useConfig();
    const {
      isCartSidebarOpen, isWishlistSidebarOpen, isLoginModalOpen, toggleLoginModal,
    } = useUiState();
    const logoHeight = computed(
      () => config.value.logo_height || '34',
    );

    const logoWidth = computed(
      () => config.value.logo_width || '35',
    );
    return {
      logoWidth,
      logoHeight,
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      route,
    };
  },

});
